import React from 'react';

import "./LoadingComponent.css"

// -----------------------------------
function LoadingComponent(props) {
  
  return(
    <div>
      <div id="wave">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </div>
  );
}

export default LoadingComponent;
